// Registers the finops plugin and lazily loads the dashboard page component
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

// Plugin registration with its root route
export const finopsPlugin = createPlugin({
  id: 'finops',
  routes: {
    root: rootRouteRef,
  },
});

export const FinOpsDashboardPage = finopsPlugin.provide(
  createRoutableExtension({
    name: 'FinOpsDashboardPage',
    component: () =>
      import('./components/FinOpsDashboardPage').then(
        m => m.FinOpsDashboardPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
